import React, { useMemo } from "react"

import type { ChartData, TooltipItem } from "chart.js"

import { DoughnutChartElement } from "../../elements/doughnutChart.element"
import type { IPoliciesAggregatedChartValues } from "../../types/objects.types"

export const PoliciesAggregationsChartComponent: React.FunctionComponent<
    IPoliciesAggregationsChartComponentProps
> = props => {
    const chartData = useMemo<ChartData<"doughnut", number[], any>>(() => {
        return {
            labels: props.data.map(item => item.label),
            datasets: [
                {
                    data: props.data.map(item => item.value),
                    backgroundColor: props.data.map(item => item.color),
                    borderWidth: 0,
                },
            ],
        }
    }, [props.data])

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
            style={{
                width: `${props.widthPercentage || 100}%`,
            }}
        >
            <DoughnutChartElement
                data={chartData}
                redraw={false}
                hoveredChartLabel={props.hoveredLabel}
                tooltipGetLabelCallback={(item: TooltipItem<"doughnut">) => {
                    const config = props.data.find(
                        inner => inner.value === item.parsed,
                    )

                    if (!config) {
                        return item.parsed.toString()
                    }

                    return `${item.parsed} (${config.percentage}%)`
                }}
            />
        </div>
    )
}

interface IPoliciesAggregationsChartComponentProps {
    className?: string
    data: IPoliciesAggregatedChartValues[]
    widthPercentage?: number
    hoveredLabel?: string
}
